export class SaveData {
	firstTimeUser = true;
	certificateSeen = false;
	highScores: { [key: string]: number } = {};
	totalScore = 0;
	unlockedLevels: { [key: string]: boolean } = {};
}
